var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubOffering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224.72727272727047 197.8314477737265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-sub-offering-1",
    opacity: 1,
    x: 60,
    y: 60,
    width: 104.72727272727047,
    height: 77.83144777372655
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-sub-offering-2",
    filterUnits: "userSpaceOnUse",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow",
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0.7333333333333333  0 0 0 0 1  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-sub-offering-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M133.67913066900365,91.5997624558608 L127.97801747184835,91.5997624558608 C127.17217368930974,86.79815584039119 125.28724024394647,82.3650122808384 122.5779378716184,78.55756070303119 L126.6094724273647,74.52300610962743 L119.16699565414896,67.07495414914513 L115.13546109840269,71.10719136483871 C111.33085956187703,68.3958594439413 106.89871875791474,66.50951398786395 102.10302199458873,65.70306654472525 L102.10302199458873,60 L91.57842431746819,60 L91.57842431746819,65.70538392243542 C86.78041191108892,66.51183136557412 82.35058675017987,68.39817682165148 78.54598521365423,71.10950874254888 L74.51445065790793,67.07495414914513 L67.06965824163895,74.52068873191726 L71.10119279738524,78.55524332532102 C68.39189042505717,82.36269490312824 66.5069569796939,86.79815584039119 65.7011131971553,91.59744507815063 L60,91.59744507815063 L60,102.1299267708675 L65.70574448326184,102.1299267708675 C66.51158826580044,106.9315333863371 68.39189042505717,111.36467694588988 71.10119279738524,115.17212852369711 L67.06965824163895,119.2113178725212 L74.51213501485466,126.6593698330035 L78.5483008567075,122.6201804841794 C82.35290239323315,125.33151240507681 86.78041191108892,127.22480999428467 91.57842431746819,128.02894005971322 L91.57610867441491,117.26703797368964 C82.496472262536,114.92648648641924 75.79036998026072,106.67893921592872 75.79036998026072,96.86484461336414 C75.79036998026072,85.22929113060695 85.21503720707715,75.79756385022023 96.84188097755509,75.79756385022023 C108.46872474803303,75.79756385022023 117.89339197484946,85.22929113060695 117.89339197484946,96.86484461336414 C117.89339197484946,98.68398611584661 117.66414331257553,100.447510553285 117.2311180616137,102.13224414857767 L133.68144631205692,102.13224414857767 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-sub-offering-4",
    opacity: 1,
    fillRule: "evenodd",
    d: "M81.05151099729433,110.7946020291879 C83.79323237236818,113.90452291623434 87.43805453821805,116.19640947159121 91.57610867441483,117.26240321826883 L91.5784243174681,128.02430530429243 C86.78041191108886,127.2178578611537 82.35290239323311,125.32687764965601 78.54830085670748,122.61554572875859 L74.51213501485466,126.6547350775827 L67.06965824163899,119.20436573939023 L71.10350844043853,115.1674937682763 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-sub-offering-5",
    x1: 0.26974678760393045,
    y1: 0.10410221923335541,
    x2: 0.9494520030234316,
    y2: 1.0716879623402826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "rgb(0,77,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "rgb(0,120,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "rgb(0,168,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "rgb(0,186,255)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-sub-offering-6",
    opacity: 1,
    fillRule: "evenodd",
    d: "M91.57610867441281,117.26935535140025 C93.25958117414145,117.7027049832018 95.0241011807346,117.93444275421867 96.84188097755302,117.93444275421867 C98.65966077437143,117.93444275421867 100.42186513791131,117.70502236091197 102.10533763763996,117.27167272911042 L102.10533763763996,133.73664135985896 L91.58073996051935,133.73664135985896 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-sub-offering-7",
    opacity: 1,
    fillRule: "evenodd",
    d: "M120.0700964449229,111.76326591203863 L131.23612724779977,122.93534385276203 L157.2847959540548,96.86716199107411 L164.72727272727053,104.31521395155637 L131.23612724779977,137.83144777372655 L112.62761967170718,119.2113178725209 L120.0700964449229,111.76326591203863Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-sub-offering-1",
    fill: "black",
    filter: "url(#filter-sub-offering-2)",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-sub-offering-3",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-sub-offering-4",
    fill: "url(#linearGradient-sub-offering-5)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-sub-offering-6",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-sub-offering-7",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubOffering);
export default __webpack_public_path__ + "static/media/sub-offering.f5f75199d3d6c2eaa0df0cc293239a1d.svg";
export { ForwardRef as ReactComponent };